import { useEventListener } from '@cheqroom/hooks';
import { useState } from 'react';

import { type Location } from '../../../@types/python.d';

interface UseGlobalLocationFilterProps {
	/** Called on every nav location change, including `null` for "All locations". */
	onLocationChanged?: (location: Location | null) => void;
}

/**
 * Navigation has a location dropdown that can be used to only show items/kits/reservations/checkouts/etc.
 * for a specific location.
 *
 * @returns The selected location filter.
 */
export const useGlobalLocationFilter = ({ onLocationChanged }: UseGlobalLocationFilterProps = {}) => {
	const [location, setLocation] = useState<Location | null>(() => window.global.central.location());

	useEventListener('location:changed', (event) => {
		// `null` is the "All locations" selection (and the archived-location reset) — consumers
		// must be told about it so per-page location filters are cleared too.
		const { location: next } = (event as CustomEvent<{ location: Location | null }>).detail;
		setLocation(next);
		onLocationChanged?.(next);
	});

	return location;
};
